import React, { useState } from "react";
import { Form, Tab, Tabs } from "react-bootstrap";
import { defaultLocation } from "../RetailerSettingsConstants";
import SettingsLocationsFormik from "./SettingsLocationsFormik";
import SettingsLocationsFormView from "./SettingsLocationsFormView";
import styles from "../RetailerSettings.module.scss";
// import GoogleLogin from "react-google-login";
import { GoogleLogin, useGoogleLogin } from "@react-oauth/google";
import Api from "src/data/api";
import { useEffect } from "react";
import { DEFAULT_ACTIVE_TAB_KEY, TABS } from "./SettingsLocationsConstans";
import dynamic from "next/dynamic";

const DynamicEditor = dynamic(() => import("../../Editor"), {
    ssr: false,
});

const getMappedLocationsSettings = (
    virtualEmails = [],
    locationsEmails = {},
    fullLocations = [],
    locationsPhoneNumbers = {},
    virtualPhoneNumbers = [],
    locationsSelectedCalendars = [],
    virtualSelectedCalendars = ""
) => {
    const mappedVirtualEmails = virtualEmails.map(
        (virtualEmail) => virtualEmail.email
    );

    const mappedVirtualPhoneNumbers = virtualPhoneNumbers.map(
        (phonenumber) => phonenumber.phonenumber
    );
    const locationsSettings = {};

    locationsSettings[defaultLocation.value] = {
        email: mappedVirtualEmails[0] || "",
        additionalEmails: mappedVirtualEmails.slice(1),
        phoneNumber: mappedVirtualPhoneNumbers[0] || "",
        phoneNumbers: mappedVirtualPhoneNumbers.slice(1),
        selectedCalendars: virtualSelectedCalendars,
    };

    fullLocations.forEach((location) => {
        locationsSettings[location.locationId] = {
            email: (locationsEmails[location.locationId] || [])[0] || "",
            additionalEmails: (
                locationsEmails[location.locationId] || []
            ).slice(1),
            phoneNumber:
                (locationsPhoneNumbers[location.locationId] || [])[0] || "",
            phoneNumbers: (
                locationsPhoneNumbers[location.locationId] || []
            ).slice(1),
            selectedCalendars:
                (locationsSelectedCalendars[location.locationId] || [])[0] ||
                "",
        };
    });

    return locationsSettings;
};

const getConnectedCalendarInfo = (
    mappedCalendars,
    mappedVirtualCalendars,
    userId,
    mappedLocationSettings,
    currentLocationId
) => {
    let message = "";
    // console.log("getConnectedCalenderInfo", mappedLocationSettings)
    // console.log("getConnectedCalenderInfo currentLocationId", currentLocationId)
    const currentConnectedCalendarId =
        mappedLocationSettings[currentLocationId].selectedCalendars;

    const calendar =
        mappedCalendars[currentConnectedCalendarId] ||
        mappedVirtualCalendars[currentConnectedCalendarId];

    if (calendar && calendar.user_id !== userId) {
        message = `A calendar has already been connected ${calendar.calendar_summary} by ${calendar.user_email}`;
    }

    return message;
};

const SettingsLocations = ({ locationsSettings, setRefetch, user, flags }) => {
    const [calendars, setCalendars] = useState([]);

    const handleGoogleAuthCode = async ({ code }) => {
        const { data } = await Api.request({
            method: "POST",
            url: "/retailer/user/google-auth-code",
            data: { code },
        });

        setCalendars(data.calendars);
    };

    const handleGoogleError = (...args) => {
        console.log(args);
    };

    const login = useGoogleLogin({
        onSuccess: (codeResponse) => handleGoogleAuthCode(codeResponse),
        onError: handleGoogleError,
        flow: "auth-code",
        scope: "https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/calendar.events.readonly",
    });

    useEffect(() => {
        setCalendars([...locationsSettings.calendars]);
    }, [locationsSettings.calendars]);
    const locationsDropdownValues = [
        ...locationsSettings.fullLocations
            .map((location) => ({
                ...location,
                value: location.locationId,
                title: `${location.neighborhood} - ${location.address}`,
            })),
        { ...defaultLocation },
    ];
    console.log("LocationsDropdownValues", locationsSettings.fullLocations)
    console.log(locationsSettings);

    const defLocation = locationsSettings.fullLocations.length
        ? {
            value: locationsDropdownValues[0].locationId,
            title: locationsDropdownValues[0].address,
            locationSignupId:
                locationsDropdownValues[0].locationSignupId,
        }
        : defaultLocation;

    const [currentLocation, setCurrentLocation] = useState({
        ...defLocation,
    });

    const mappedLocationSettings = getMappedLocationsSettings(
        locationsSettings.virtualEmails,
        locationsSettings.locationsEmails,
        locationsSettings.fullLocations,
        locationsSettings.locationsPhoneNumbers,
        locationsSettings.virtualPhoneNumbers,
        locationsSettings.locationsSelectedCalendars,
        locationsSettings.virtualCalendars
    );

    // console.log("CurrentLocation", currentLocation)
    const connectedCalendarInfo = getConnectedCalendarInfo(
        locationsSettings.mappedCalendars,
        locationsSettings.mappedVirtualCalendars,
        user.user_id,
        mappedLocationSettings,
        currentLocation.value
    );

    const fetchEmailContents = async () => {
        let { data } = await Api.request({
            url: `/retailer/emails/location/settings?`,
            params: {
                locationId: currentLocation.value,
            },
        });

        return data;
    };

    const saveEmailContents = async (data) => {
        await Api.request({
            method: "POST",
            url: `/retailer/emails/location/settings`,
            data: {
                ...data,
                locationId: currentLocation.value,
            },
        });
    };

    return (
        <>
            <Form.Group
                controlId="input-location"
                className={`mb-2 ${styles.MarginWrapper}`}
            >
                <Form.Control
                    value={currentLocation.value}
                    as="select"
                    custom
                    style={{ minWidth: 0, maxWidth: 400 }}
                    onChange={(e) => {
                        const location = locationsDropdownValues.find(
                            (location) => location.value == e.target.value
                        );
                        setCurrentLocation(location);
                    }}
                >
                    {locationsDropdownValues.map((location) => (
                        <option
                            key={location.value}
                            value={location.value}
                            data-location-signup-id={location.locationSignupId}
                        >
                            {location.title}
                        </option>
                    ))}
                </Form.Control>
            </Form.Group>
            <Tabs defaultActiveKey={DEFAULT_ACTIVE_TAB_KEY}>
                <Tab
                    title={TABS.GENERAL.title}
                    eventKey={TABS.GENERAL.eventKey}
                >
                    <SettingsLocationsFormik
                        setRefetch={setRefetch}
                        currentLocation={currentLocation}
                        locationSettings={{
                            ...mappedLocationSettings[currentLocation.value],
                        }}
                        userCalendars={calendars}
                    >
                        {(props) => (
                            <SettingsLocationsFormView
                                currentLocation={currentLocation}
                                calendars={calendars}
                                connectedCalendarInfo={connectedCalendarInfo}
                                login={login}
                                externalCalendarSyncEnabled={
                                    flags?.external_calendar_sync_enabled
                                }
                                {...props}
                            />
                        )}
                    </SettingsLocationsFormik>
                </Tab>
                <Tab
                    title={TABS.CUSTOMIZATION.title}
                    eventKey={TABS.CUSTOMIZATION.eventKey}
                >
                    <DynamicEditor
                        locationId={currentLocation.value}
                        fetchEmailContents={fetchEmailContents}
                        saveEmailContents={saveEmailContents}
                    />
                </Tab>
            </Tabs>
        </>
    );
};

export default SettingsLocations;
